<template>
  <v-container>
    <v-card>
      <v-toolbar dark color="primary">

        <v-toolbar-title> Toplu Seçenek Seçimi</v-toolbar-title>
        <v-spacer></v-spacer>

      </v-toolbar>
      <!-- <v-card-title class="headline">
          Unvan Seçimi
        </v-card-title> -->

      <v-card-text>
        <v-textarea
        
          v-model="selectedItem"
          label="Veri Seçimi"
          value=""
          hint="Buraya Excel yada tablonun kolonunu kopyalarak yazabilirsiniz. "
        ></v-textarea>
        <!-- <v-autocomplete v-model="selectedUser" :items="users" :loading="loading" :search-input.sync="search" :persistent-placeholder="true" placeholder="En az 3 harf girerek kullanıcı arayınız."
          item-text="username" item-value="username" label="Kullanıcı Seç" clearable hide-no-data hide-details>
          <template v-slot:item="{ item }">
            {{ item.ad }} {{ item.soyad }}
          </template>

        </v-autocomplete> -->
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary"  text @click="saveSelected">Seçilenleri Aktar</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import FilterUserService from "@/services/FilterUserService";
export default {
  data() {
    return {
     
      selectedUser: null, // seçilen kullanıcı id
      selectedItem: null, // seçilen kullanıcı id

    };
  },
  watch: {
  

  },
  methods: {
      saveSelected() {

      if (this.selectedItem) {

        this.$emit("selectedChange", this.selectedItem.split("\n"));

        this.selectedItem="";
      }
      else{
        this.$toast.warning("Lütfen boş bırakmayınız!");

      }


      
    },




  }
};
</script>